import { AxiosRequestConfig, AxiosAdapter } from 'axios';
import isUri from 'isuri';
import { getCookie, printGroupLog } from '../../utils';
import { get } from '../../utils/data';
import { TypeRequest } from '../../types';
const adapterInit = () =>
  function(config: AxiosRequestConfig) {
    const {
      baseURL,
      url: path,
      method = 'GET',
      params = {},
      data = {},
    } = config;
    const initProps = get('initProps');
    const fetch: TypeRequest = initProps.fetch;
    const printLog = initProps?.printLog || false;
    const url = isUri.isValid(path!) ? path : baseURL! + path!;

    // log
    if (printLog) {
      printGroupLog(
        `${method} ${url} >>>>`,
        {
          'data >>>>': data,
          'params >>>>': params,
        },
        false
      );
    }

    let requestData = {
      url,
      method: method.toUpperCase(),
      params: {
        ...params,
        is_native_h5: 1,
      },
      data,
      needCommonParams: true,
      header: {
        'x-tt-passport-csrf-token':
          getCookie('passport_csrf_token') ||
          getCookie('passport_csrf_token_default') ||
          '',
      },
    };
    return fetch(requestData).then(data => ({
      data,
      status: 200,
      statusText: 'ok',
      config,
    }));
  } as AxiosAdapter;
export default adapterInit;
